















































import { Component, Prop, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import ajax from "@/lib/ajax";
import ShiftDto from "@/models/Shifts/ShiftDto";
import { AgencyDashboardModule } from "@/store/modules/agencyDashboard";
import GenerateShiftTimesheetPdfRequest from "@/models/Shifts/GenerateShiftTimesheetPdfRequest";


@Component({
  name: "ShiftTimesheetPdfDownload",
})
export default class extends GiganautVueDialog {
  
  @Prop({required: true})
  public shift: ShiftDto;
    @Prop({required: true})
  public locationName: string;
    @Prop({required: true})
  public positionName: string;
  public isIncludeWorkerContactDetails = true;
  public filename = '';
  public dialog = false;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.isIncludeWorkerContactDetails = true;
      const start = new Date(this.shift.startAt)
      const end = new Date(this.shift.endAt)
      this.filename = this.locationName + " - " + this.positionName + " (" + start.toLocaleDateString(['en-GB'], {month: 'long', day: '2-digit', year: 'numeric' }) + " " + start.toLocaleTimeString("en-GB").replace(":00", "").replace(":", "") + "-" + end.toLocaleTimeString("en-GB").replace(":00", "").replace(":", "") + ")" + ".pdf";
    }
  }

  async download() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new GenerateShiftTimesheetPdfRequest();
    request.filename = this.filename;
    request.shiftId = this.shift.id;
    request.isIncludeContactDetails = this.isIncludeWorkerContactDetails;
		await AgencyDashboardModule.getShiftTimesheetPdf(request);
    this.dialog = false;

  }
}
